import { useCreditsControllerGetCurrentCreditSuspense } from "@/api/orval/connect";
import { useGetWhoami } from "@/api/whoami/get-whoami";

/** 残量がこの割合「以下」になったら警告する。API 側の判定（consume-credits-impl）と揃える */
const WARNING_RATIO = 0.25;

/**
 * 当月のクレジット残量。
 *
 * Suspense 版を使う（非 suspense だと取得中・失敗時に残量が既定値へ落ち、
 * 使い切ったテナントにも生成入口が開く）。
 *
 * ホストはクレジットを消費しないため、残量の表示もゲートも対象外。
 */
export const useGetCredits = (tenantId: string) => {
  const { isHost } = useGetWhoami();

  const { data } = useCreditsControllerGetCurrentCreditSuspense(tenantId);

  const { remaining, planCredits, month } = data;
  // 並行消費で残量が負に振れてもゲートが開いたままにならないよう <= で見る
  const isExhausted = !isHost && remaining <= 0;
  const isLow =
    !isHost && !isExhausted && remaining <= planCredits * WARNING_RATIO;

  return { isHost, remaining, planCredits, month, isExhausted, isLow };
};
